import { ref } from 'vue';

export const getAppConfig = () => {
  const key = TenantConfig?.tenant_key || 'root';
  const localStorageTheme = localStorage.getItem(`${key}-theme`);
  const localeStorage = localStorage.getItem(`${key}-locale`);
  const locale =
    TenantConfig?.locales.find(locale => locale.code == localeStorage)?.code ||
    TenantConfig?.locales.find(locale => locale.is_default_cms)?.code ||
    'en';
  const notificationToken = localStorage.getItem(`${key}-notification-token`);
  return {
    appConfig: {
      key: key,
      name: TenantConfig?.tenant_name,
      logoPath: TenantConfig?.logo,
      theme: ref(localStorageTheme || 'light'),
      locale: ref(locale),
      isRtl: ref(TenantConfig?.locales.find(l => l.code == locale && l.is_rtl) ? true : false),
      notificationToken: ref(notificationToken),
    },
  };
};
